import ServiceWidget from './ServiceWidget'

export default ServiceWidget
